const isObject = (value: any) => {
    return !!(value && typeof value === "object" && !Array.isArray(value));
};

interface ISubmitButtonStyles {
    [key: string]: any;
}

export const getDeclarableFormButtonsData = (neededValues: ISubmitButtonStyles) => {
    let value: ISubmitButtonStyles = {};
    const iterate = (obj: ISubmitButtonStyles, stack: string, element: string) => {
        for (let property in obj)
            if (
                isObject(obj[property]) &&
                property !== "color" &&
                property !== "hoverColor" &&
                property !== "center" &&
                property !== "markers"
            )
                iterate(obj[property], `${stack}.${property}`, element);
            else value[`buttons.${element}${stack}.${property}`] = obj[property];
    };
    Object.keys(neededValues).forEach(element => {
        iterate(neededValues[element], "", element);
    });

    return value;
};
